import removeLeadingOne from '../removeLeadingOne/removeLeadingOne';

/**
 * @var matchNonDigits
 * @type {RegExp}
 * @access private
 * @desc Regular expression used to match non digits.
 */
const matchNonDigits: RegExp = /[^0-9]/g;

/**
 * @function isValidUSPhoneNumber
 * @desc Is a phone number a valid US phone number or not.
 *
 * @param {String} number - the phone number.
 * @returns {Boolean} isValid - whether it is valid or not.
 */
const isValidUSPhoneNumber = (number: string = ''): boolean | null => {
  if (number.length > 0) {
    const onlyDigits = removeLeadingOne(number.replace(matchNonDigits, ''));

    if (Boolean(onlyDigits) && onlyDigits.length === 10) return true;

    return false;
  }

  return null;
};

export default isValidUSPhoneNumber;
